import { render, staticRenderFns } from "./knowledgeForm.vue?vue&type=template&id=7edb1712&scoped=true&"
import script from "./knowledgeForm.vue?vue&type=script&lang=js&"
export * from "./knowledgeForm.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeForm.vue?vue&type=style&index=0&id=7edb1712&scoped=true&lang=scss&"
import style1 from "./knowledgeForm.vue?vue&type=style&index=1&id=7edb1712&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edb1712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7edb1712')) {
      api.createRecord('7edb1712', component.options)
    } else {
      api.reload('7edb1712', component.options)
    }
    module.hot.accept("./knowledgeForm.vue?vue&type=template&id=7edb1712&scoped=true&", function () {
      api.rerender('7edb1712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledgeBaseMgr/knowledgeMgr/components/knowledgeForm.vue"
export default component.exports